<app-modal [title]="'Transferir pajuelas'" [scrollable]="true">
  <p class="mb-4 text-sm text-gray-600 dark:text-gray-300">
    {{ data.pajuelaIds.length }} pajuela(s) quedan reservadas en la transferencia, sin receptora.
    <!-- Las receptoras, el descongelado y la ejecución se cargan en la planilla de la transferencia. -->
    <!-- 2026-10-08: el descongelado es por embrión, al emparejarlo con la receptora.
    El descongelado se registra acá; las receptoras y los diagnósticos, en la planilla de TE. -->
    El descongelado y los diagnósticos se registran en la planilla de TE.
  </p>

  <div class="mb-4">
    <app-label for="te-cliente">Cliente de la transferencia (dueño de las receptoras)</app-label>
    <app-select id="te-cliente" [formControl]="clienteTe" placeholder="Cliente" [options]="clientesOptions" searchable />
  </div>

  @if (loading) {
    <p class="py-4 text-center text-sm text-gray-500">Cargando transferencias del cliente…</p>
  } @else {
    <!-- 2026-09-30: la TE se agenda solo desde el calendario; desde Stock las pajuelas se suman a una TE ya agendada.
    <div class="mb-4 flex flex-wrap gap-4 text-sm">
      @if (abiertas.length) {
        <label class="flex items-center gap-2">
          <input type="radio" value="existente" [formControl]="destino" /> Transferencia existente
        </label>
      }
      @if (puedeCrear) {
        <label class="flex items-center gap-2"><input type="radio" value="nueva" [formControl]="destino" /> Nueva transferencia</label>
      }
    </div>
    @if (!abiertas.length && !puedeCrear) {
      <p class="mb-4 text-sm text-warning-700">El cliente no tiene transferencias abiertas y no tenés permiso para crear una.</p>
    }

    -->
    @if (!abiertas.length) {
      <p class="mb-4 text-sm text-warning-700">El cliente no tiene transferencias agendadas. Agendala desde el calendario.</p>
    }

    @if (abiertas.length) {
      <div class="mb-5">
        <app-label for="te-existente">Transferencia</app-label>
        <app-select id="te-existente" [formControl]="existente" placeholder="Elegí una transferencia" [options]="abiertasOptions" />
      </div>
    }

    <!-- 2026-09-30: la receptora de cada embrión se elige acá; queda Asignada y se cambia en la planilla. -->
    @if (existente.value && lineas.length) {
      <div class="mb-5">
        <p class="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">Receptoras</p>
        @if (cargandoTe) {
          <p class="text-sm text-gray-500">Cargando receptoras de la transferencia…</p>
        } @else if (!receptorasTe.length) {
          <p class="text-sm text-gray-500">La transferencia no tiene receptoras cargadas en el agendamiento.</p>
        } @else {
          <div class="max-h-72 overflow-auto">
            <app-receptoras-por-embrion [lineas]="lineas" [receptoras]="receptorasTe" [ocupadas]="ocupadas" />
          </div>
        }
      </div>
    }
    <!-- 2026-09-30: sin "Nueva transferencia"; los datos del agendamiento se cargan en el calendario.
    } @else {
      <app-form [formGroup]="nueva">
        <div class="mb-5 grid grid-cols-1 gap-3 md:grid-cols-2">
          <div class="md:col-span-2">
            <app-label for="te-nueva-establecimiento">Establecimiento de las receptoras</app-label>
            <app-select id="te-nueva-establecimiento" formControlName="cli_establecimiento_id" placeholder="Establecimiento" [options]="establecimientosOptions" />
          </div>
          <div>
            <app-label for="te-nueva-fecha">Fecha de inicio</app-label>
            <app-input-field id="te-nueva-fecha" formControlName="fecha" type="date" />
          </div>
          <div>
            <app-label for="te-nueva-fecha-fin">Fecha de terminación</app-label>
            <app-input-field id="te-nueva-fecha-fin" formControlName="fecha_fin" type="date" />
          </div>
          <!-- 2026-09-29: como en el alta del calendario, inicio y terminación reemplazan a la hora.
          <div>
            <app-label for="te-nueva-hora">Hora</app-label>
            <app-input-field id="te-nueva-hora" formControlName="hora" type="time" />
          </div>
          - ->
          <div>
            <app-label for="te-nueva-cantidad">Cantidad de receptoras</app-label>
            <app-input-field id="te-nueva-cantidad" formControlName="cantidad_receptoras" type="number" [min]="1" />
          </div>
          <div>
            <app-label for="te-nueva-tecnico">Técnico responsable de la transferencia</app-label>
            <app-select id="te-nueva-tecnico" formControlName="param_tecnico_transferencista_id" placeholder="Seleccione un técnico" [options]="tecnicosOptions" searchable />
          </div>
          <div class="md:col-span-2">
            <app-label for="te-nueva-protocolo">Protocolo de sincronización de receptoras</app-label>
            <app-file-input id="te-nueva-protocolo" formControlName="protocolo" [extensiones]="extensionesProtocolo" [accept]="acceptProtocolo" />
          </div>
          <div class="md:col-span-2">
            <app-label for="te-nueva-raza">Raza de las receptoras nuevas</app-label>
            <app-select id="te-nueva-raza" formControlName="param_raza_id" placeholder="Raza" [options]="razasOptions" searchable />
          </div>
          <div class="md:col-span-2">
            <app-label>Receptoras</app-label>
            <app-planilla-receptoras formControlName="receptoras" [existentes]="rpsExistentes" [pelajes]="pelajes" />
          </div>
        </div>
      </app-form>
    }
    -->
  }

  @if (!loading) {
    <!-- 2026-10-08: el descongelado se carga por embrión en la planilla de TE.
    <!~~ 2026-09-24: el descongelado se hace en el laboratorio al sacar las pajuelas del termo. ~~>
    <app-form [formGroup]="descongelado">
      <p class="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">Descongelado</p>
      <div class="mb-1 grid grid-cols-1 gap-3 md:grid-cols-3">
        <div>
          <app-label for="descongelado-fecha">Fecha</app-label>
          <app-input-field id="descongelado-fecha" formControlName="fecha" type="date" />
        </div>
        <div>
          <app-label for="descongelado-hora">Hora</app-label>
          <app-input-field id="descongelado-hora" formControlName="hora" type="time" />
        </div>
        <!~~ 2026-10-05: sin hora límite de uso.
        <div>
          <app-label for="descongelado-limite">Hora límite de uso</app-label>
          <app-input-field id="descongelado-limite" formControlName="hora_limite" type="time" />
        </div>
        ~~>
      </div>
      <p class="mb-5 text-xs" [class.text-gray-500]="!errorDescongelado" [class.text-error-600]="!!errorDescongelado">
        {{ errorDescongelado || 'Dejá la hora vacía si todavía no se descongelaron.' }}
      </p>
    </app-form>
    -->
  }

  <app-creation-buttons
    [valid]="valido"
    [process]="guardando"
    (onCreateClick)="transferir()"
    (onCancelClick)="cancelar()"
  />
</app-modal>
